import { useCallback, useEffect, useState } from 'react'
import { listFiles, listJobs, normalizeApiError } from '../services/api'
import { useAppStore } from '../stores/appStore'

let hasHydratedSession = false

export function useSessionData() {
  const { setFiles, setJobs } = useAppStore()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refresh = useCallback(async () => {
    try {
      setError(null)
      const [files, jobs] = await Promise.all([listFiles(), listJobs(100)])
      setFiles(files)
      setJobs(jobs)
    } catch (err) {
      setError(normalizeApiError(err))
    } finally {
      setIsLoading(false)
    }
  }, [setFiles, setJobs])

  useEffect(() => {
    if (!hasHydratedSession) {
      hasHydratedSession = true
      refresh()
    } else {
      setIsLoading(false)
    }
  }, [refresh])

  return {
    isLoading,
    error,
    refresh,
  }
}
